import { Component, Input } from '@angular/core';

@Component({
  selector: 'om-label-with-tooltip',
  templateUrl: './label-with-tooltip.component.html',
  styles: [],
})
export class LabelWithTooltipComponent {
  @Input() tooltip: string;
  @Input() label: string;
}
